module.exports = __webpack_public_path__ + "img/bz.64d617ea.svg";